const Cancel01Icon = /*#__PURE__*/ [
  ["path", { d: "M18 6L6.00081 17.9992M17.9992 18L6 6.00085", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { Cancel01Icon as default };
//# sourceMappingURL=Cancel01Icon.js.map
